import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-labelledby="guarantee-title" className="bg-white" data-id="element-88" data-mp="1o46konudlsx5">
      <div className="mx-auto max-w-2xl px-5 py-16 text-center sm:py-20" style={{
      paddingTop: "15px",
      paddingBottom: "0px"
    }} data-id="element-89" data-mp="1o5zs45ctch67">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border-2 border-gold" data-id="element-90" data-mp="1x3tnne2r76sb">
          <ShieldCheckIcon className="h-8 w-8 text-gold" aria-hidden="true" data-id="element-91" data-mp="19dzdj49tjwbr" />
        </span>
        <h2 id="guarantee-title" className="mt-6 font-display text-2xl font-black text-ink sm:text-3xl" data-id="element-92" data-mp="14g63u19b4k6q">
          7-Day Money-Back Guarantee
        </h2>
        <p className="mt-5 text-base leading-relaxed text-ink" data-id="element-93" data-mp="1j6n8rul5hs8d">Try THE REALTOR AI PLAYBOOK™ for 7 days.</p>
        <p className="mt-3 text-base leading-relaxed text-ink" data-id="element-94" data-mp="1ec0unjnoplkl">
          If you decide it’s not the right fit for your workflow, you can request a refund according to the terms of the
          guarantee. No complicated process.
        </p>
        <p className="mt-5 text-sm leading-relaxed text-muted" data-id="element-95" data-mp="p0b6ptplh6ew">
          SIGMA SMART™ is committed to delivering practical digital systems designed to help professionals get more value from
          modern AI tools.
        </p>
      </div>
    </section>;
}